import './styles.scss'

import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import I18n from 'lib/i18n'

import Course from './course'

import similarCoursesArrowIcon from '../_assets/similar-courses-arrow-icon.svg'

const STEP_BY = 5
const DIV_WIDTH = 154
const GAP = 12
const DESKTOP_WITH_IN_BETWEEN_BREAKPOINT = 950

const SimilarCourses = ({ courses, dpr, i18nLocale }) => {
  const [position, setPosition] = useState(0)
  const [containerWidth, setContainerWidth] = useState(0)

  const totalCourses = courses.length

  const stepSize = DIV_WIDTH + GAP
  const totalContentWidth = totalCourses * (DIV_WIDTH + GAP) - GAP

  const isRTL = i18nLocale === 'ar'

  useEffect(() => {
    const updateWidth = () => {
      const screenWidth = window.innerWidth
      const scrollbarWidth = screenWidth - document.documentElement.clientWidth
      let availableWidth

      if (screenWidth >= 1440) {
        availableWidth = 1105
      } else {
        let margin = 32

        if (screenWidth >= 950 && screenWidth <= 1007) {
          margin = 40 * 2
        } else if (screenWidth >= 1008 && screenWidth < 1440) {
          margin = 80 * 2
        }

        availableWidth = screenWidth - margin - scrollbarWidth
      }
      setContainerWidth(availableWidth)
    }

    updateWidth()

    window.addEventListener('resize', updateWidth)
    return () => window.removeEventListener('resize', updateWidth)
  }, [])

  const overflow = Math.max(totalContentWidth - containerWidth, 0)
  const needsNavigation = overflow > 0

  const clamp = position => Math.max(0, Math.min(position, overflow))

  const handlePrevious = () => {
    const screenWidth = window.innerWidth
    setPosition(previousPosition =>
      clamp(previousPosition - (screenWidth >= DESKTOP_WITH_IN_BETWEEN_BREAKPOINT ? stepSize * STEP_BY : stepSize))
    )
  }

  const handleNext = () => {
    const screenWidth = window.innerWidth
    setPosition(previousPosition =>
      clamp(previousPosition + (screenWidth >= DESKTOP_WITH_IN_BETWEEN_BREAKPOINT ? stepSize * STEP_BY : stepSize))
    )
  }

  const isAtStart = position <= 0
  const isAtEnd = position >= overflow

  const translateX = isRTL ? position : -position

  return (
    <div className='similar-courses-container'>
      <div className='title-navigation'>
        <div className='similar-courses-title'>{I18n.t('courses.show.similar_classes')}</div>
        {needsNavigation && (
          <div className='similar-courses-navigation'>
            <img
              className={`arrow-icon-previous${isAtStart ? ' start' : ''}`}
              alt='arrow icon previous'
              src={`${similarCoursesArrowIcon}`}
              width={32}
              height={32}
              onClick={handlePrevious}
            />
            <img
              className={`arrow-icon-next${isAtEnd ? ' end' : ''}`}
              alt='arrow icon next'
              src={similarCoursesArrowIcon}
              width={32}
              height={32}
              onClick={handleNext}
            />
          </div>
        )}
      </div>
      <div
        className='similar-courses-content'
        style={{
          transform: `translateX(${translateX}px)`,
          transition: 'transform 300ms cubic-bezier(0.4, 0, 0.2, 1)'
        }}
      >
        {courses.map(course => (
          <React.Fragment key={course.id}>
            <Course key={`${course.id}-1`} height={188} width={154} course={course} dpr={dpr} />
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}

SimilarCourses.propTypes = {
  courses: PropTypes.array,
  dpr: PropTypes.number,
  i18nLocale: PropTypes.string
}

export default SimilarCourses
